import styled from 'styled-components/macro';

export const HomeStyle = styled.div`
    margin-inline: 20px;
    padding-block: 75px;
`

export const PocketSection = styled.div`
`
export const CurrencySection = styled.div`
`